import setupAxios from '@utilities/setupAxios'
import { getPropertyDetailApi, getPropertiesApi } from './Api'
import { getCurrentTimestamp } from './Utilities'

// Window
setupAxios()

const fetchAllPropertySummaries = (dispatch: any) => {
  return getPropertiesApi()
    .then((response) => {
      dispatch({
        type: 'LOAD_ALL_PROPERTY_SUMMARIES_AND_BECOME_READY',
        timestamp: getCurrentTimestamp(),
        payload: response.data.results
      })
    })
    .catch((err) => {
      dispatch({
        type: 'ERROR_PROPERTIES',
        message: err.message
      })
    })
}

const fetchPropertyDetails = (dispatch: any, propertyId: any) => {
  return getPropertyDetailApi(propertyId)
    .then((response) => {
      dispatch({
        type: 'LOAD_PROPERTY_DETAILS_AND_BECOME_READY',
        timestamp: getCurrentTimestamp(),
        payload: response.data
      })
    })
    .catch((err) => {
      dispatch({
        type: 'ERROR_PROPERTIES',
        message: err.message
      })
    })
}

const refreshPropertyInfo = (dispatch: any, summaryPropertyIds: any, detailsPropertyIds: any) => {
  // If any property summaries are stale, start with a promise that first fetches them all.
  // Otherwise start with a resolved promise.  Then fetch all the needed details in parallel.
  // Finally, transition back to the Ready state.

  function startingPromise(): Promise<any> {
    if (summaryPropertyIds.length > 0) {
      return getPropertiesApi().then((response) => {
        dispatch({
          type: 'LOAD_ALL_PROPERTY_SUMMARIES',
          timestamp: getCurrentTimestamp(),
          payload: response.data.results
        })
      })
    } else {
      return Promise.resolve(1)
    }
  }

  startingPromise()
    .then(() => {
      const promises = detailsPropertyIds.map((propertyId: any) => {
        return getPropertyDetailApi(propertyId)
          .then((response) => {
            dispatch({
              type: 'LOAD_PROPERTY_DETAILS',
              timestamp: getCurrentTimestamp(),
              payload: response.data
            })
          })
          .catch((err) => {
            // We simply ignore errors.  Such properties will stay
            // un-refreshed until the next periodic refresh.
            console.log('FAILED: getPropertyDetailApi', propertyId, err)
          })
      })
      return Promise.all(promises)
    })
    .then(() => {
      dispatch({
        type: 'FINISH_LOADING'
      })
    })
    .catch((err) => {
      console.log('ERROR:', err)
    })
}

export const runCommand = (command: any, dispatch: any, _state: any) => {
  switch (command.type) {
  case 'CMD_FETCH_PROPERTY_DETAILS':
    fetchPropertyDetails(dispatch, command.propertyId)
    return

  case 'CMD_FETCH_ALL_PROPERTY_SUMMARIES':
    fetchAllPropertySummaries(dispatch)
    return

  case 'CMD_REFRESH_PROPERTY_INFO':
      //console.log(CMD_REFRESH_PROPERTY_INFO, command.summaryPropertyIds, command.detailsPropertyIds)
    refreshPropertyInfo(dispatch, command.summaryPropertyIds, command.detailsPropertyIds)
    return
  }
}
